import React from "react";

const Subscriptions = () => {
  return (
    <React.Fragment>
      <div className="card rounded-3 shadow mx-lg-5 mx-md-3 mx-sm-1 my-4 p-xxl-5 py-3 text-center flex-fill">
        <h2>INVESTMENT PLANS</h2>
        <div className="container">
          <div className="row mb-4 pt-3">
            <div className="col-md-3 col-sm-12 my-2 d-flex flex-column">
              <div
                className="rounded-4 mb-3 py-3 text-white"
                style={{ backgroundColor: "#acd373" }}
              >
                <h5>GREEN CARROT</h5>
              </div>
              <div
                className="rounded-top-4 py-2 text-white"
                style={{ backgroundColor: "#acd373" }}
              >
                <h5>FREE</h5>
              </div>
              <div
                className="rounded-bottom-4 p-3 d-flex flex-column flex-fill"
                style={{ backgroundColor: "#eefed6" }}
              >
                <h5>Plan Details</h5>
                <div className="table-responsive flex-fill">
                  <table
                    className="table table-sm"
                    style={{
                      "--bs-table-bg": "#eefed6",
                      "--bs-table-border-color": "#acd373",
                    }}
                  >
                    <tbody className="text-start">
                      <tr>
                        <td>Submit missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#acd373" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Submit special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#acd373" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-times"
                            style={{ color: "#acd373" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-times"
                            style={{ color: "#acd373" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions on special offers:
                          <br />
                          5% commission + 55 EGP processing fees on submissions.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fixed comission:
                          <br />
                          20000 LE for numbers more than 400000 LE.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Minimum wage:
                          <br />
                          EGP 55 (minimum per mission) + 15 LE / from the second
                          hour.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  href="#"
                  className="btn rounded-4 text-white px-3 my-3"
                  data-bs-toggle="modal"
                  data-bs-target="#login"
                  style={{ backgroundColor: "#acd373" }}
                >
                  REGISTER / LOGIN
                </a>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 my-2 d-flex flex-column">
              <div
                className="rounded-4 mb-3 py-3"
                style={{ backgroundColor: "#fff799" }}
              >
                <h5>YELLOW CARROT</h5>
              </div>
              <div
                className="rounded-top-4 py-2"
                style={{ backgroundColor: "#fff799" }}
              >
                <h5>
                  PRICE <del>100</del> 25 PER YEAR
                </h5>
              </div>
              <div
                className="rounded-bottom-4 p-3 d-flex flex-column flex-fill"
                style={{ backgroundColor: "#fdfadb" }}
              >
                <h5>Plan Details</h5>
                <div className="table-responsive flex-fill">
                  <table
                    className="table table-sm"
                    style={{
                      "--bs-table-bg": "#fdfadb",
                      "--bs-table-border-color": "#fff799",
                    }}
                  >
                    <tbody className="text-start">
                      <tr>
                        <td>Submit missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{
                              color: "#fff799",
                              textShadow: "0 0 1px #000",
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Submit special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{
                              color: "#fff799",
                              textShadow: "0 0 1px #000",
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{
                              color: "#fff799",
                              textShadow: "0 0 1px #000",
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-times"
                            style={{
                              color: "#fff799",
                              textShadow: "0 0 1px #000",
                            }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions on special offers:
                          <br />
                          3% commission + 10 EGP processing fees on submissions.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fixed comission:
                          <br />
                          20000 LE for numbers more than 400000 LE.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Minimum wage:
                          <br />
                          EGP 55 (minimum per mission) + 15 LE / from the second
                          hour.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions:
                          <br />
                          15% full missions commission on delivery.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  href="#"
                  className="btn rounded-4 px-3 my-3"
                  style={{ backgroundColor: "#fff799" }}
                >
                  OWN
                </a>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 my-2 d-flex flex-column">
              <div
                className="rounded-4 mb-3 py-3"
                style={{ backgroundColor: "#fdc689" }}
              >
                <h5>ORANGE CARROT</h5>
              </div>
              <div
                className="rounded-top-4 py-2"
                style={{ backgroundColor: "#fdc689" }}
              >
                <h5>
                  PRICE <del>200</del> 100 PER YEAR
                </h5>
              </div>
              <div
                className="rounded-bottom-4 p-3 d-flex flex-column flex-fill"
                style={{ backgroundColor: "#fdebd6" }}
              >
                <h5>Plan Details</h5>
                <div className="table-responsive flex-fill">
                  <table
                    className="table table-sm"
                    style={{
                      "--bs-table-bg": "#fdebd6",
                      "--bs-table-border-color": "#fdc689",
                    }}
                  >
                    <tbody className="text-start">
                      <tr>
                        <td>Submit missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#fdc689" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Submit special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#fdc689" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#fdc689" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#fdc689" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions on special offers:
                          <br />
                          1.5% commission on submissions (no processing fees),
                          5% commission on delivery.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fixed comission:
                          <br />
                          20000 LE for numbers more than 400000 LE.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Minimum wage:
                          <br />
                          EGP 500 (minimum per mission).
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions:
                          <br />
                          10% full missions commission on delivery.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  href="#"
                  className="btn rounded-4 px-3 my-3"
                  style={{ backgroundColor: "#fdc689" }}
                >
                  OWN
                </a>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 my-2 d-flex flex-column">
              <div
                className="rounded-4 mb-3 py-3"
                style={{ backgroundColor: "#bd8cbf" }}
              >
                <h5>ORANGE CARROT</h5>
              </div>
              <div
                className="rounded-top-4 py-2"
                style={{ backgroundColor: "#bd8cbf" }}
              >
                <h5>
                  PRICE <del>200</del> 100 PER YEAR
                </h5>
              </div>
              <div
                className="rounded-bottom-4 p-3 d-flex flex-column flex-fill"
                style={{ backgroundColor: "#f1e5f2" }}
              >
                <h5>Plan Details</h5>
                <div className="table-responsive flex-fill">
                  <table
                    className="table table-sm"
                    style={{
                      "--bs-table-bg": "#f1e5f2",
                      "--bs-table-border-color": "#bd8cbf",
                    }}
                  >
                    <tbody className="text-start">
                      <tr>
                        <td>Submit missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#bd8cbf" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Submit special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#bd8cbf" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for missions</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#bd8cbf" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td>Apply for special offers</td>
                        <td className="text-end">
                          <i
                            className="fa fa-check"
                            style={{ color: "#bd8cbf" }}
                          ></i>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions on special offers:
                          <br />
                          1.5% commission + 10 EGP processing fees on
                          submissions.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fixed comission:
                          <br />
                          20000 LE for numbers more than 400000 LE.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Minimum wage:
                          <br />
                          EGP 55 (minimum per mission) + 15 LE / from the second
                          hour.
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          Fees and commissions:
                          <br />
                          10% full missions commission on delivery.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  href="#"
                  className="btn rounded-4 px-3 my-3"
                  style={{ backgroundColor: "#bd8cbf" }}
                >
                  OWN
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Subscriptions;
